export default "__VITE_ASSET__D$E6cWkr__"